module.exports = __webpack_public_path__ + "img/calcasieu-river-bridge.f3df89b7.jpg";